export default {
    env: process.env.NODE_ENV,
    development: {
        ajaxUrl: '',
        staticUrl: '',
        cookiePath: '/'
    },
    production: {
        ajaxUrl: '',
        staticUrl: '',
        cookiePath: '/'
    }
}